import script from "./CreatedClient.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatedClient.vue?vue&type=script&setup=true&lang=js"

import "./CreatedClient.vue?vue&type=style&index=0&id=23b52d94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23b52d94"]])

export default __exports__